import { useRef, useState } from "react";

export const useOverview3dCalcAreaObjects = () => {
    const [state, setState] = useState([]);
    const ref = useRef(state);

    const setStateAndRef = val => {
        setState(val);
        ref.current = val;
    };
    return [state, setStateAndRef, ref];
};